import { useCallback, useEffect, useState } from 'react'
import { ConversationProvider } from '@elevenlabs/react'
import BenBubble from './BenBubble'
import BenModal from './BenModal'

export default function BenConversation({ hideBubble = false } = {}) {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback((source = 'external') => {
    console.log('[Ben] Opening chat from:', source)
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'chat_opened', {
        event_category: 'ben_ai_assistant',
        event_label: 'elevenlabs_sdk',
        page_location: window.location.href,
        source,
      })
    }
    setIsOpen(true)
  }, [])

  const close = useCallback(() => setIsOpen(false), [])

  // Preserve global API for existing CTAs (BenTV, HeroSectionNew, etc.)
  useEffect(() => {
    window.openBenChat = open
    return () => {
      if (window.openBenChat === open) delete window.openBenChat
    }
  }, [open])

  return (
    <ConversationProvider>
      {!isOpen && !hideBubble && <BenBubble onOpen={() => open('bubble')} />}
      {isOpen && <BenModal onClose={close} />}
    </ConversationProvider>
  )
}
